import { render } from "./RegionSearchView.vue?vue&type=template&id=552f09f7&scoped=true"
import script from "./RegionSearchView.vue?vue&type=script&lang=js"
export * from "./RegionSearchView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-552f09f7"

export default script